import moment from 'moment'
import { call } from 'redux-saga/effects'

export const timeIsAfterTransactionStartDate = (limit: moment.Moment, now: moment.Moment) => now.isAfter(limit)

export interface ViewMapDataRecordAccumulator { [K: string]: number }

export const mapFunction = (acc: ViewMapDataRecordAccumulator, value: ViewMapDataRecord, i: number) => {
    if (value.code !== 'ZZ') {
        acc[value.code] = i
    }
    return acc
}

export const isMapDataDifferent = (record: MapDataItem, mapDataSource: string, oldValues: ViewMapDataRecord[], oldValuesDictionary: ViewMapDataRecordAccumulator) => {
    const quantity = mapDataSource === 'Dollars' ? record.totalDollars : record.recordCount
    const quantitySelector = mapDataSource === 'Dollars' ? 'value' : 'donors'
    return oldValues[oldValuesDictionary[record.name]] && oldValues[oldValuesDictionary[record.name]][quantitySelector] !== quantity
}

export const getEChartsActions = (boundDispatchAction: (...args: any[]) => void, name: string, type: 'highlight' | 'downplay') =>
    call(boundDispatchAction, { name, type })

export const validateSettings: (settings: DataApiSettings) => boolean = settings =>
    settings.transactionStartDateTime !== 'Invalid Date' &&
    settings.formIds && settings.formIds.length > 0
